module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("A Small Creation of Literature")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#about-the-book"
    }
  }, [_vm._v("About the Book")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#copyright-information"
    }
  }, [_vm._v("Copyright Information")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#acknowledgements"
    }
  }, [_vm._v("Acknowledgements")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#a-bunch-of-flowers"
    }
  }, [_vm._v("A Bunch of Flowers")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#answering-back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Answering Back")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#arranged-marriage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arranged Marriage")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#first-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#for-the-love-of-cricket",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("For the Love of Cricket")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#my-mother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Mother")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#passing-of-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Passing of Time")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#the-last-leaf",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Last Leaf")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#the-room",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Room")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#the-room-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Room")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#characters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Characters"), _c('strong', [_vm._v(":")])])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#scene-1-in-the-room-on-a-rainy-afternoon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 1: In the Room on a Rainy Afternoon")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#scene-2-in-the-room.-in-the-evening.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 2: In the Room. In the Evening.")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#scene-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 3:")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#section",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#kulvinder-kherteru",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Kulvinder Kherteru")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#saturday-25-march-2017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Saturday, 25 March 2017")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#the-successor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Successor")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#scene-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 1")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#scene-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 2")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#scene-3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 3")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#scene-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scene 4")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0